import { MutationTree } from "vuex";
import { AuthState } from "./types";

export const mutations: MutationTree<AuthState> = {
  setToken(state, token: string) {
    state.token = token;
    window.localStorage.setItem("dpaID-token", token);
  },

  setStatus(state, payload) {
    state.status = payload;
  }
};
